import {renderCartSocialProof} from "../../modules/social-proof";

function applyCouponCode(couponCode, isAutoApply) {

    $('.js-promo-error-msg').removeClass('is-error');
    $('#promocode-error').text('').hide();
    if(couponCode === ""){
        couponCode = $('#promo').val();
    }
    if(couponCode) {
        var successCallBack = function (obj) {
            if (obj.success) { // coupon applied ok but applied with restriction or with 0 amount
                if (!obj.msg10) { // coupon not applied
                    $('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
                    $('#summary_coupon').hide();
                    $('#summary_coupon_code').text('').hide();
                    $('.coupon_applied').hide();
                    $('#promo').val('');
                    if(obj.msg15){
                        $('#totalAfterPayPayment').html(obj.msg15);
                    }
                    return;
                } else if (obj.msg4) { // invalid promo code
                    $('#coupon_applied_invalid').html('');
                    $('#summary_coupon').hide();
                    $('#total').text(obj.msg3);

                } else {
                    $('#promo').data('applied-coupon-code', couponCode);
                    if (obj.msg14) { // for restrictions
                        $('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
                    } else {
                        $('#coupon_applied_invalid').html('').hide();
                    }
                    $('#discountAmount').html(obj.msg2);
                    $('#summary_coupon').show();
                    $('#summary_coupon_code').text('Promo Code: ' + couponCode).show();
                    $('#summary_coupon_amount').text(obj.msg2).show();
                    $('#total').text(obj.msg3);
                    $('.coupon_applied').show();
                    $('#promo').val('');
                    if(obj.msg15){
                        $('#totalAfterPayPayment').html(obj.msg15);
                    }
                }
                if(typeof isAutoApply == "undefined" || !isAutoApply){
                    updateMiniBag(false);
                }
            } else { // Invalid coupon code.
                $('.js-promo-error-msg').addClass('is-error');
                $('#promocode-error').text(obj.msg4 ? obj.msg4 : 'Invalid code').show();
                if(obj.msg15){
                    $('#totalAfterPayPayment').html(obj.msg15);
                }
            }
        }
        applyPromo(couponCode, successCallBack);
    }
}

function removeCoupon(){
    var successCallBack = function (obj){
        $('#summary_coupon').hide();
        $('#coupon_applied_invalid').html('').hide();
        $('#summary_coupon_code').text('');
        $('#summary_coupon_amount').text('');
        $('#total').text(obj.msg3);
        $('.coupon_applied').hide();
        $('#promo').data('applied-coupon-code', "");
        if(obj.msg15){
            $('#totalAfterPayPayment').html(obj.msg15);
        }
        updateMiniBag(false);
    }
    applyPromo("", successCallBack);
}

function reApplyCouponForCartRefresh(){
    if(window.shoppingBagCoupenCodeABtest){
        let appliedCouponCode = $('#promo').data('applied-coupon-code');
        if(appliedCouponCode)
            applyCouponCode(appliedCouponCode, true);
    }
}

$(function() {
    $('.js-lazy-image').lazy({
        effect: 'fadeIn'
    });

    renderCartSocialProof($('.js-cart-item').toArray().map((el) => $(el).data('code')));
});

window.reApplyCouponForCartRefresh = reApplyCouponForCartRefresh;
window.removeCoupon = removeCoupon;
window.applyCouponCode = applyCouponCode;



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/index.js